import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "crud-container" }
const _hoisted_2 = {
  key: 0,
  class: "dialog"
}
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { class: "dialog-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.isEdit ? 'Edit Item' : 'Create Item'), 1),
            _createElementVNode("label", null, [
              _cache[9] || (_cache[9] = _createTextVNode(" First Name ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemForm.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.name]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[10] || (_cache[10] = _createTextVNode(" Last Name ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.itemForm.lastName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.lastName]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[11] || (_cache[11] = _createTextVNode(" Mail ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.itemForm.mail) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.mail]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[12] || (_cache[12] = _createTextVNode(" Invoice Address 1 ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemForm.invoiceAddress) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.invoiceAddress]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[13] || (_cache[13] = _createTextVNode(" Invoice Address 2 ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.itemForm.invoiceAddress) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.invoiceAddress]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[14] || (_cache[14] = _createTextVNode(" Invoice Mail ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.itemForm.invoiceMail) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.invoiceMail]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[15] || (_cache[15] = _createTextVNode(" Invoice Mobile ")),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.itemForm.invoiceMobile) = $event))
              }, null, 512), [
                [_vModelText, _ctx.itemForm.invoiceMobile]
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, { to: "/admin/about-me" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialog = false)),
                    class: "cancel-btn"
                  }, "Cancel")
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveItem && _ctx.saveItem(...args))),
                class: "save-btn"
              }, _toDisplayString(_ctx.isEdit ? 'Save' : 'Create'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}